import styles from './style.module.scss';
import { useRef } from 'react';
import { useScroll, motion, useTransform } from 'framer-motion';
import Magnetic from '../../common/Magnetic/Magnetic.js';

export default function Contact() {



    const container = useRef(null);
    const { scrollYProgress } = useScroll({
        target: container,
        offset: ["start end", "end end"]
    })
    const rotate = useTransform(scrollYProgress, [0, 1], [120, 90])



    const handleEmailClick = () => {
        window.location.href = 'mailto:asferali8384@gmail.com';
    };

    const handlePhoneClick = () => {
        window.location.href = 'tel:+918220958384'; 
    };


    return (
        <motion.div className={styles.contact}>
            <div className={styles.body} id="Contact">
                <div className={styles.title}>
                    {/* <span>
                    </span> */}
                    <div>
                        <div>
                            {/* <div className={styles.imageContainer}>
                                <img
                                    fill={true}
                                    alt={"image"}
                                    src={`/images/background.jpg`}
                                />
                            </div> */}
                            <h2 style={{ letterSpacing: "1px", fontSize: "50px" }}>Let's work together</h2>
                        </div>
                        {/* <div> */}
                        <motion.svg style={{ rotate, scale: 2 }} width="9" height="9" viewBox="0 0 9 9" fill="true" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 8.5C8.27614 8.5 8.5 8.27614 8.5 8L8.5 3.5C8.5 3.22386 8.27614 3 8 3C7.72386 3 7.5 3.22386 7.5 3.5V7.5H3.5C3.22386 7.5 3 7.72386 3 8C3 8.27614 3.22386 8.5 3.5 8.5L8 8.5ZM0.646447 1.35355L7.64645 8.35355L8.35355 7.64645L1.35355 0.646447L0.646447 1.35355Z" fill="white" />
                        </motion.svg>
                        {/* </div> */}
                    </div>
                </div>
                <div className={styles.nav}>
                    <div>

                        <Magnetic >
                            <p className='contact-gmail' onClick={handleEmailClick} style={{ cursor: "pointer" }}>asferali8384@gmail.com</p>
                        </Magnetic>


                        <Magnetic >
                            <p className='contact-phone' onClick={handlePhoneClick} style={{ letterSpacing: "2px", cursor: "pointer" }}>+91 82 20 95 83 84</p>
                        </Magnetic>
                    </div>
                </div>
                <div className={styles.info}>
                    <div className={styles.right}>
                        <span>
                            <p>2023 © Edition</p>
                        </span>
                        {/* <span className={styles.time}>
                            <p><img src={Location} style={{ width: "15px", height: "15px" }} />India - {currentTime}</p>
                        </span> */}
                    </div>
                    <div>
                        <span>
                            <Magnetic>
                                <p className='magnetic'> <a style={{ color: "white" }} href="https://www.instagram.com/asfer_8384/" target="_blank">Instagram</a> </p>
                            </Magnetic>
                        </span>
                        <Magnetic>
                            <p>  <a style={{ color: "white" }} href="https://www.linkedin.com/in/mohamed-asfer-ali-3011421bb" target="_blank">Linkedin</a> </p>
                        </Magnetic>
                        <Magnetic>
                            <p><a style={{ color: "white" }} href="https://github.com/ASFER8384" target="_blank">Github</a></p>
                        </Magnetic>
                        <Magnetic>
                            <p><a style={{ color: "white" }} href="https://drive.google.com/file/d/1zcpnJEIO49hMnXlT7LW2eVh48B3_ZLfN/view?usp=sharing" target="_blank">Resume</a></p>
                        </Magnetic>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}
